// src/services/firebase.js
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  sendEmailVerification, 
  signInWithPhoneNumber, 
  RecaptchaVerifier 
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyC98ast3RIEB_q1fUw1UelP92wAr92Fiik",
  authDomain: "fmlcforms.firebaseapp.com",
  projectId: "fmlcforms",
  storageBucket: "fmlcforms.firebasestorage.app",
  messagingSenderId: "824225231426",
  appId: "1:824225231426:web:11410c8f5fe4e1987ff3db",
  measurementId: "G-FVEJQ98SW8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

// Export auth functions
export { sendEmailVerification, signInWithPhoneNumber, RecaptchaVerifier };

// User roles
export const USER_ROLES = {
  ADMIN: 'admin',
  MEMBER_COORDINATOR: 'member_coordinator',
  PARTNER_COORDINATOR: 'partner_coordinator',
  CLUB_COORDINATOR: 'club_coordinator',
  USER: 'user'
};

export default app;